import { request } from './helpers/request'
import { GENERIC_MFA_ERROR_CODE } from '../constants/error.codes'

export default (data) =>
  request({
    url: '/users/mfa/totp/register',
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(data),
  }).then((response) => {
    if (response.status === 204) {
      return Promise.resolve(response)
    } else if (response.status === 400) {
      return Promise.reject(new Error(response.data.code))
    } else {
      return Promise.reject(new Error(GENERIC_MFA_ERROR_CODE))
    }
  })
